import React from 'react'

function Footer() {
  return (
    <div>
   <footer class="bg-gray-800 text-white">
    <div class="container px-6 py-12 mx-auto">


        <div class="grid grid-cols-2 gap-6 mt-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            <div>
                <h3 class="text-sm font-bold  ">Internship by places</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                <p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">New York</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Los Angeles</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Chicago</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">San Francisco</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Miami</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Seattle</p>
                </div>
            </div>

            <div>
                <h3 class="text-sm font-bold  ">Internship by stream</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                <p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">About us</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Careers</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Press</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">News</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Media kit</p>
<p class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Contact</p>

                </div>
            </div>

            <div>
                <h3 class="text-sm font-bold  ">Job Places</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Blog</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Newsletter</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Events</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Help center</a>                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Tutorials</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Supports</a>
                </div>
            </div>

            <div>
                <h3 class="text-sm font-bold  ">Jobs by streams</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Startups</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Enterprise</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Government</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Saas</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Marketplaces</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Ecommerce</a>
                </div>
            </div>

           

          
        </div>
        
        <hr class="my-6 border-gray-200 md:my-10 dark:border-gray-700"/>
        <div>
                <h3 class="text-sm font-bold  ">About us</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Startups</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Enterprise</a>
                 
                </div>
            </div>
        <div>
                <h3 class="text-sm font-bold  ">Team diary</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Startups</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Enterprise</a>
                 
                </div>
            </div>
        <div>
                <h3 class="text-sm font-bold  ">Terms and conditions</h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Startups</a>
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Enterprise</a>
                 
                </div>
            </div>
        <div>
                <h3 class="text-sm font-bold  ">sitemap </h3>

                <div class="flex flex-col items-start mt-4 space-y-4">
                    <a href="/" class=" transition-colors duration-200 dark dark:hover:text-blue-400 hover:underline hover:text-blue-600">Startups</a>
            
                 
                </div>
            </div>
        <div class="flex flex-col items-center justify-between sm:flex-row">
          <p className='border-white' >
          <i class="bi bi-google-play text-black"></i>  Get Android App
          </p>
          <div class="social-icons">
  <i class="fab fa-facebook"></i>
  <i class="fab fa-twitter"></i>
  <i class="fab fa-instagram"></i>

</div>
            <p class="mt-4 text-sm  sm:mt-0 dark">© Copyright 2023. All Rights Reserved.</p>
        </div>
    </div>
</footer>

    </div>
  )
}

export default Footer
